import ReleaseNotes from '../components/release_notes/ReleaseNotes'

const ReleaseNotesPage = () => {
    return <ReleaseNotes />
}

export default ReleaseNotesPage
